export class ResetPassword{
    public email: string 
    public verificationCode: string
    public  Password: string
}


export class CreateProfile{
    public UserId: string 
    public FirstName: string 
    public LastName: string 
    public UserName: string 
    public Email: string 
    public  Password: string
    public  DPFile: any
}